'use client'

import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { colors } from '../../theme/colors'
import GridContainer from '../GridContainer'

type GradientSectionItem = {
  itemTitle: string
  itemDescription: string
  icon?: IconProp
}

interface GradientSectionProps {
  title: string
  items: GradientSectionItem[]
  variant?: 'default' | 'reversed'
}

const GradientSection: FC<GradientSectionProps> = ({ title, items, variant = 'default' }) => (
  <div
    className={`
    py-16 md:py-24
    md:bg-gradient-to-r md:from-ink-100 md:to-green-300
    bg-gradient-to-b ${
      variant === 'reversed' ? 'from-green-300 to-ink-100' : 'from-ink-100 to-green-300'
    }
  `}
  >
    <GridContainer>
      <div className="col-span-full mb-8 lg:mb-16">
        <Typography variant="h2" className="hidden lg:block">
          {title}
        </Typography>
        <Typography variant="h2" sx={{ color: colors.Green[900] }} className="block lg:hidden">
          {title}
        </Typography>
      </div>
      <div className="col-span-full flex flex-col lg:flex-row gap-6">
        {items.map(({ itemTitle, itemDescription, icon }) => (
          <div key={itemTitle} className="flex-1">
            {icon && (
              <Typography variant="h2" sx={{ color: colors.Green[600] }}>
                <FontAwesomeIcon icon={icon} className="mb-4 lg:mb-6" />
              </Typography>
            )}
            <div className="flex flex-col gap-2 lg:gap-3">
              <Typography variant="h4" sx={{ color: colors.Ink[900] }}>
                {itemTitle}
              </Typography>
              <Typography variant="p2" sx={{ color: colors.Ink[600] }}>
                {itemDescription}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </GridContainer>
  </div>
)

export default GradientSection
